import { render, staticRenderFns } from "./detailModel.vue?vue&type=template&id=02c64a5e&scoped=true"
import script from "./detailModel.vue?vue&type=script&lang=js"
export * from "./detailModel.vue?vue&type=script&lang=js"
import style0 from "./detailModel.vue?vue&type=style&index=0&id=02c64a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c64a5e",
  null
  
)

export default component.exports